const baseTheme = {
  heroTitle: "Sunday Ledger - Built for Elite Fantasy Football.",
  heroBody:
    "A refined record of standings, championships, rivalries, and league history, shaped by seasons on the board and incredible league trips to the Ozarks and Nashville.",
};

export const themes = [
  {
    id: "classy",
    name: "Classy Feel",
    description: "Polished editorial look with warm caramel and gold tones.",
    heroEyebrow: "Private League Archives",
    ...baseTheme,
    styles: {
      "--page-bg": "#18120f",
      "--page-gradient": "radial-gradient(circle at top, rgba(255, 205, 104, 0.28), transparent 30%), linear-gradient(180deg, #3a2a1d 0%, #18120f 100%)",
      "--page-surface": "linear-gradient(180deg, rgba(255,255,255,0.015), rgba(0,0,0,0.02))",
      "--page-pattern": "none",
      "--header-bg": "rgba(52, 37, 26, 0.78)",
      "--accent": "#f0b84f",
      "--accent-soft": "#ffd98d",
      "--text-main": "#fbf4ea",
      "--muted-text": "#dcc8aa",
      "--border-soft": "rgba(255, 217, 141, 0.18)",
      "--border-strong": "rgba(255, 217, 141, 0.45)",
      "--nav-shell-bg": "rgba(255, 248, 237, 0.08)",
      "--nav-hover-bg": "rgba(255, 248, 237, 0.12)",
      "--nav-active-bg": "linear-gradient(135deg, #fff1cf, #f0c46a)",
      "--nav-active-text": "#1f130b",
      "--mobile-nav-bg": "rgba(49, 35, 25, 0.95)",
      "--hero-bg": "linear-gradient(135deg, rgba(78, 55, 37, 0.96), rgba(41, 29, 21, 0.9))",
      "--panel-strong-bg": "rgba(62, 45, 31, 0.76)",
      "--panel-soft-bg": "rgba(255, 248, 237, 0.08)",
      "--table-shell-bg": "rgba(55, 40, 28, 0.68)",
      "--table-head-bg": "rgba(46, 34, 25, 0.92)",
      "--table-head-text": "#f3d498",
      "--table-body-bg": "rgba(35, 26, 19, 0.74)",
      "--table-sticky-bg": "rgba(35, 26, 19, 0.96)",
      "--table-text": "#f7eada",
      "--highlight-bg": "linear-gradient(135deg, rgba(240, 184, 79, 0.4), rgba(255, 233, 187, 0.12))",
      "--highlight-text": "#fff7ea",
      "--pill-bg": "rgba(240, 184, 79, 0.2)",
      "--pill-border": "rgba(255, 217, 141, 0.34)",
      "--pill-text": "#fff0cb",
      "--card-bg-default": "linear-gradient(135deg, rgba(255, 248, 237, 0.1), rgba(255, 248, 237, 0.04))",
      "--card-bg-accent": "linear-gradient(135deg, rgba(240, 184, 79, 0.34), rgba(255, 236, 199, 0.12))",
      "--card-bg-cool": "linear-gradient(135deg, rgba(192, 150, 92, 0.28), rgba(255, 248, 237, 0.08))",
      "--font-body": "\"Avenir Next\", \"Segoe UI\", \"Trebuchet MS\", sans-serif",
      "--font-display": "\"Iowan Old Style\", \"Palatino Linotype\", \"Book Antiqua\", serif",
    },
  },
  {
    id: "sportsbook",
    name: "Old Sportsbook Ledger",
    description: "Ink, paper, and odds-board energy with vintage greens and tan stock.",
    heroEyebrow: "House Ledger",
    ...baseTheme,
    styles: {
      "--page-bg": "#161712",
      "--page-gradient": "linear-gradient(180deg, #242720 0%, #161712 100%)",
      "--page-surface": "linear-gradient(180deg, rgba(0,0,0,0.03), rgba(255,255,255,0.01))",
      "--page-pattern": "repeating-linear-gradient(180deg, rgba(218, 201, 150, 0.04) 0, rgba(218, 201, 150, 0.04) 1px, transparent 1px, transparent 32px)",
      "--header-bg": "rgba(28, 31, 26, 0.96)",
      "--accent": "#c6b26b",
      "--accent-soft": "#e4d4a2",
      "--text-main": "#f0e4c7",
      "--muted-text": "#b9b091",
      "--border-soft": "rgba(208, 191, 135, 0.22)",
      "--border-strong": "rgba(208, 191, 135, 0.55)",
      "--nav-shell-bg": "rgba(233, 223, 192, 0.06)",
      "--nav-hover-bg": "rgba(233, 223, 192, 0.1)",
      "--nav-active-bg": "#d2be88",
      "--nav-active-text": "#1f211b",
      "--mobile-nav-bg": "rgba(31, 34, 28, 0.98)",
      "--hero-bg": "rgba(50, 54, 45, 0.97)",
      "--panel-strong-bg": "rgba(40, 43, 36, 0.94)",
      "--panel-soft-bg": "rgba(229, 221, 195, 0.08)",
      "--table-shell-bg": "rgba(34, 37, 31, 0.96)",
      "--table-head-bg": "rgba(27, 29, 24, 0.97)",
      "--table-head-text": "#d8c58d",
      "--table-body-bg": "rgba(24, 26, 22, 0.98)",
      "--table-sticky-bg": "rgba(24, 26, 22, 0.97)",
      "--table-text": "#efe3bf",
      "--highlight-bg": "rgba(198, 178, 107, 0.18)",
      "--highlight-text": "#fff2cf",
      "--pill-bg": "rgba(198, 178, 107, 0.18)",
      "--pill-border": "rgba(198, 178, 107, 0.32)",
      "--pill-text": "#f1dfab",
      "--card-bg-default": "rgba(229, 221, 195, 0.05)",
      "--card-bg-accent": "rgba(198, 178, 107, 0.14)",
      "--card-bg-cool": "rgba(112, 124, 86, 0.14)",
      "--font-body": "\"Franklin Gothic Medium\", \"Arial Narrow\", \"Segoe UI\", sans-serif",
      "--font-display": "\"Bookman Old Style\", Georgia, serif",
    },
  },
  {
    id: "trophy",
    name: "Trophy Room",
    description: "Dark walnut, brass, and plaque-like surfaces built around awards.",
    heroEyebrow: "Hall of Honors",
    ...baseTheme,
    styles: {
      "--page-bg": "#120f0d",
      "--page-gradient": "linear-gradient(180deg, #311b14 0%, #1a100d 100%)",
      "--page-surface": "linear-gradient(90deg, rgba(132, 58, 38, 0.14) 0%, rgba(120, 49, 33, 0.08) 18%, rgba(92, 38, 26, 0.14) 36%, rgba(116, 47, 31, 0.08) 54%, rgba(86, 34, 24, 0.14) 72%, rgba(110, 44, 30, 0.08) 100%), linear-gradient(180deg, rgba(255,255,255,0.015), rgba(0,0,0,0.08))",
      "--page-pattern": "repeating-linear-gradient(90deg, rgba(52, 20, 14, 0.22) 0, rgba(52, 20, 14, 0.22) 1px, transparent 1px, transparent 118px), repeating-linear-gradient(90deg, rgba(255, 226, 180, 0.025) 0, rgba(255, 226, 180, 0.025) 2px, transparent 2px, transparent 37px)",
      "--header-bg": "rgba(36, 23, 17, 0.95)",
      "--accent": "#d4ad5b",
      "--accent-soft": "#f2dfb4",
      "--text-main": "#fff7eb",
      "--muted-text": "#d2bd96",
      "--border-soft": "rgba(220, 186, 110, 0.2)",
      "--border-strong": "rgba(220, 186, 110, 0.52)",
      "--nav-shell-bg": "rgba(255, 245, 225, 0.06)",
      "--nav-hover-bg": "rgba(255, 245, 225, 0.12)",
      "--nav-active-bg": "#cb9f46",
      "--nav-active-text": "#24160d",
      "--mobile-nav-bg": "rgba(35, 23, 18, 0.97)",
      "--hero-bg": "rgba(69, 43, 30, 0.98)",
      "--panel-strong-bg": "rgba(60, 39, 29, 0.92)",
      "--panel-soft-bg": "rgba(255, 245, 225, 0.08)",
      "--table-shell-bg": "rgba(50, 33, 24, 0.96)",
      "--table-head-bg": "rgba(37, 23, 17, 0.95)",
      "--table-head-text": "#f0d393",
      "--table-body-bg": "rgba(28, 19, 14, 0.98)",
      "--table-sticky-bg": "rgba(26, 18, 14, 0.97)",
      "--table-text": "#fdf1d9",
      "--highlight-bg": "rgba(212, 173, 91, 0.22)",
      "--highlight-text": "#fff6e1",
      "--pill-bg": "rgba(212, 173, 91, 0.18)",
      "--pill-border": "rgba(212, 173, 91, 0.34)",
      "--pill-text": "#f8e6bc",
      "--card-bg-default": "rgba(255, 245, 225, 0.05)",
      "--card-bg-accent": "rgba(212, 173, 91, 0.14)",
      "--card-bg-cool": "rgba(152, 104, 70, 0.14)",
      "--font-body": "\"Segoe UI\", \"Gill Sans\", \"Trebuchet MS\", sans-serif",
      "--font-display": "\"Palatino Linotype\", \"Book Antiqua\", \"Baskerville\", serif",
    },
  },
  {
    id: "trophy2",
    name: "Trophy Room 2",
    description: "Dark walnut, brass, and plaque-like surfaces built around awards.",
    heroEyebrow: "Hall of Honors",
    ...baseTheme,
    styles: {
      "--page-bg": "#120f0d",
      "--page-gradient": "linear-gradient(180deg, #291b15 0%, #120f0d 100%)",
      "--page-surface": "linear-gradient(180deg, rgba(255,255,255,0.01), rgba(0,0,0,0.04))",
      "--page-pattern": "repeating-linear-gradient(90deg, rgba(181, 136, 73, 0.035) 0, rgba(181, 136, 73, 0.035) 1px, transparent 1px, transparent 56px)",
      "--header-bg": "rgba(36, 23, 17, 0.95)",
      "--accent": "#d4ad5b",
      "--accent-soft": "#f2dfb4",
      "--text-main": "#fff7eb",
      "--muted-text": "#d2bd96",
      "--border-soft": "rgba(220, 186, 110, 0.2)",
      "--border-strong": "rgba(220, 186, 110, 0.52)",
      "--nav-shell-bg": "rgba(255, 245, 225, 0.06)",
      "--nav-hover-bg": "rgba(255, 245, 225, 0.12)",
      "--nav-active-bg": "#cb9f46",
      "--nav-active-text": "#24160d",
      "--mobile-nav-bg": "rgba(35, 23, 18, 0.97)",
      "--hero-bg": "rgba(69, 43, 30, 0.98)",
      "--panel-strong-bg": "rgba(60, 39, 29, 0.92)",
      "--panel-soft-bg": "rgba(255, 245, 225, 0.08)",
      "--table-shell-bg": "rgba(50, 33, 24, 0.96)",
      "--table-head-bg": "rgba(37, 23, 17, 0.95)",
      "--table-head-text": "#f0d393",
      "--table-body-bg": "rgba(28, 19, 14, 0.98)",
      "--table-sticky-bg": "rgba(26, 18, 14, 0.97)",
      "--table-text": "#fdf1d9",
      "--highlight-bg": "rgba(212, 173, 91, 0.22)",
      "--highlight-text": "#fff6e1",
      "--pill-bg": "rgba(212, 173, 91, 0.18)",
      "--pill-border": "rgba(212, 173, 91, 0.34)",
      "--pill-text": "#f8e6bc",
      "--card-bg-default": "rgba(255, 245, 225, 0.05)",
      "--card-bg-accent": "rgba(212, 173, 91, 0.14)",
      "--card-bg-cool": "rgba(152, 104, 70, 0.14)",
      "--font-body": "\"Segoe UI\", \"Gill Sans\", \"Trebuchet MS\", sans-serif",
      "--font-display": "\"Palatino Linotype\", \"Book Antiqua\", \"Baskerville\", serif",
    },
  },
];

export const defaultThemeId = "trophy";
export const isThemeTestingEnabled = process.env.REACT_APP_ENABLE_THEME_TESTING === "true";

export function getThemeById(themeId) {
  return themes.find((theme) => theme.id === themeId) || themes[0];
}

export const theme = getThemeById(defaultThemeId);
